import useEmblaCarousel from 'embla-carousel-react';

import { ProgressiveImg } from 'components/base';
import { useI18n } from 'context/i18n';
import { useProductSheet } from 'context/productSheet';
import { dataLayerHandleEvent } from 'utils/dataLayers';
import { IS_CAMPER } from 'utils/constants';

import styles from './style.module.css';

export function ProductBrands() {
  const { t } = useI18n();
  const [emblaRef] = useEmblaCarousel({ skipSnaps: true, containScroll: 'trimSnaps' });

  const { productSheet } = useProductSheet();

  const filteredBrandProducts = productSheet?.brandProducts?.filter((brandProduct) => brandProduct.url) ?? [];

  const hasItems = filteredBrandProducts.length > 0;

  const handleClickBrandProduct = (productBrand) => {
    const url = new URL(productBrand.url);
    dataLayerHandleEvent({
      event: 'eventGA',
      eventCat: 'productDetail',
      eventAct: 'selectColour',
      eventLbl: productBrand.id,
    });

    dataLayerHandleEvent({
      event: 'item_photos',
      event_category: 'product detail',
      event_detail_1: 'open',
      event_detail_2: productBrand.image,
    });

    window.location.assign(url.pathname);
  };

  if (!hasItems) return null;

  // el primero es si es giftCard el segundo si no es giftCard
  return (
    <div className="">
      <p className="mb-2 text-base camper:hidden">{t('ficha.producto', 'colores', 'Colores')}:</p>
      {IS_CAMPER ?
        <div className="-mx-8 overflow-hidden md:hidden">
          <div
            style={{
              '--slide-height': '4.5rem',
              '--slide-gap': '0.625rem',
            }}
            ref={emblaRef}
            className="mx-8"
          >
            <div className="-ml-[var(--slide-gap)] flex touch-pan-y touch-pinch-zoom">
              {filteredBrandProducts.map((productBrand, index) => (
                <div
                  key={`${productBrand.id}-${index}`}
                  className={`relative ml-[var(--slide-gap)] size-18 min-w-0 shrink-0 grow-0 basis-auto ${productBrand.id === productSheet.code ? 'after:absolute after:bottom-0 after:block after:h-0.5 after:w-full after:border-t-2 after:border-[var(--color-black)]' : ''}`}
                >
                  <button className="h-full w-full" onClick={(e) => handleClickBrandProduct(productBrand)}>
                    <ProgressiveImg
                      src={productBrand.image}
                      alt={`thumbnail image ${index} of ${productBrand.id}`}
                      otherProps={{
                        width: 72,
                        height: 72,
                        className: styles.brandThumbnail,
                      }}
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      : null}
      <div className="flex flex-row flex-wrap gap-2.5 camper:max-md:hidden md:gap-1">
        {filteredBrandProducts.map((productBrand, index) => (
          <div
            key={`${productBrand.id}-${index}`}
            className={`relative size-18 md:size-15 ${productBrand.id === productSheet.code ? 'after:absolute after:bottom-0 after:block after:h-0.5 after:w-full after:border-t-2 after:border-[var(--color-black)]' : ''}`}
          >
            <button
              className="h-full w-full [&_img]:h-full [&_img]:w-full [&_picture]:flex [&_picture]:h-full [&_picture]:w-full"
              onClick={(e) => handleClickBrandProduct(productBrand)}
            >
              <ProgressiveImg
                src={productBrand.image}
                alt={`thumbnail image ${index} of ${productBrand.id}`}
                otherProps={{
                  className: `${styles.brandThumbnail} size-18 md:size-15`,
                }}
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
